/* eslint-disable */
/* tslint:disable */

/** getOffers
 * method: get
 * summary: Get offers based on the provided context and filters. If no filters are specified, all offers will be returned
 */

import type { GetOffersResponseDto, ApiResponseDto } from './../api-types'

export const path = `/bff-worker/offers`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/offers`

export type GetOffersSuccess = GetOffersResponseDto
export type GetOffersError = ApiResponseDto
